import { Material } from "three";
import { getFramePositions } from "shared/utils/door";
import { BeamVertical } from "../components/BeamVertical";
import { getGeometryBounds2D } from "../components/openingGeometry";
import { PaneelGLTFResult } from "../paneel/PaneelType";
import type { VerticalBeamPosition } from "entities/configurator/model/layoutMeta";
import { standingPanelBeamInsetMeters } from "entities/configurator/model/layoutGeometry";
import { getLocalVerticalBeamX } from "./verticalLayoutUtils";

export const PaneelVerticalLayout = ({
  nodes,
  material,
  width,
  height,
  semanticPosition,
}: {
  nodes: PaneelGLTFResult["nodes"];
  material: Material;
  width: number;
  height: number;
  semanticPosition: VerticalBeamPosition | undefined;
}) => {
  const isVisible = semanticPosition !== undefined;
  const positions = getFramePositions(width, height);
  const leftBounds = getGeometryBounds2D(nodes.frame_left.geometry);
  const rightBounds = getGeometryBounds2D(nodes.frame_right.geometry);
  const topBounds = getGeometryBounds2D(nodes.frame_top.geometry);
  const bottomBounds = getGeometryBounds2D(nodes.frame_bottom.geometry);
  const beamBounds = getGeometryBounds2D(nodes.beam_vertical.geometry);
  // Paneel's Frame rotates the reversed side nodes by 180 degrees.
  const left = -(leftBounds.maxX + positions.right.x);
  const right = -(rightBounds.minX + positions.left.x);
  const top = topBounds.minY + positions.top.y;
  const bottom = bottomBounds.maxY + positions.bottom.y;
  const beamX = isVisible
    ? getLocalVerticalBeamX(semanticPosition, left, right, beamBounds, {
        insetMeters: standingPanelBeamInsetMeters,
      })
    : 0;

  return (
    <BeamVertical
      visible={isVisible}
      geometry={nodes.beam_vertical.geometry}
      material={material}
      x={beamX}
      bottom={bottom}
      top={top}
      scaleX={1}
    />
  );
};
